<div class="knowledge-menu">
  <div class="knowledge-menu__list" #listRef>
    <span *ngIf="limitReached" class="knowledge-menu__empty">
      Você pode consultar um documento por mensagem
    </span>

    <span *ngIf="!limitReached && loading" class="knowledge-menu__empty">
      Carregando documentos...
    </span>

    <ng-container *ngIf="!limitReached && !loading">
      <button
        *ngFor="let document of navigableDocuments; let i = index"
        type="button"
        class="knowledge-menu__item"
        [class.knowledge-menu__item--active]="i === highlightedIndex"
        (mouseenter)="setHighlight(i)"
        (mouseleave)="setHighlight(-1)"
        (click)="onDocumentClick(document)"
      >
        <i [class]="iconClass(document)"></i>
        <span class="knowledge-menu__title">{{ label(document) }}</span>
      </button>

      <span *ngIf="!navigableDocuments.length" class="knowledge-menu__empty">
        {{
          hasAvailableDocuments
            ? 'Nenhum documento encontrado'
            : 'Nenhum documento disponível para consulta'
        }}
      </span>

      <span *ngIf="truncated" class="knowledge-menu__note">
        Refine a busca para ver os demais documentos
      </span>
    </ng-container>
  </div>
</div>
